module.exports = __webpack_public_path__ + "static/media/gwan.19080503.png";